import React from 'react';
import { X } from 'lucide-react';

const ImagePreviewModal = ({ isOpen, imagePreview, onClose }) => {
  if (!isOpen || !imagePreview) return null;

  return (
    <div 
      className="modal-overlay"
      onClick={onClose}
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 60 }}
    >
      <div className="relative max-w-4xl max-h-full">
        <button 
          onClick={onClose}
          className="modal-close-btn absolute top-2 right-2"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
          title="닫기"
        >
          <X className="w-5 h-5" />
        </button>
        <img 
          src={imagePreview} 
          alt="Profile Preview Large" 
          className="max-w-full max-h-full object-contain rounded-lg"
          onClick={(e) => e.stopPropagation()}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-4 rounded-b-lg">
          <p className="text-center text-sm">프로필 사진 미리보기 - ESC 키나 바깥 영역을 클릭하여 닫기</p>
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
